// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__nsAwd","Wrapper":"Header_Wrapper__DBpi9","Logo":"Header_Logo__cDQzd","Button":"Header_Button__ptHKC"};